// extracted by mini-css-extract-plugin
export default {"page":"gi-z","cartModal":"hi-z","checkout":"ii-z","placeholder":"ji-z","account":"ki-z"};